import React from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fas } from "@fortawesome/free-solid-svg-icons"
library.add(fas)

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Header       from "./components/Header"
import KpiStrip     from "./components/KpiStrip"
import LinesSection from "./components/LinesSection"
import TiersSection from "./components/TiersSection"

const DangerZone = ({ paths }) => (
  <div className="border-t border-slate-200 pt-6 mt-8">
    <div className="flex items-start justify-between gap-4 p-4 rounded-lg border border-rose-200 bg-rose-50/40">
      <div>
        <div className="text-sm font-medium text-slate-900">
          {I18n.t("mbc_contracts.delete", { defaultValue: "Supprimer ce marché" })}
        </div>
        <div className="text-xs text-slate-600 mt-0.5">
          {I18n.t("mbc_contracts.delete_confirm", { defaultValue: "Supprimer ce marché ?" })}
        </div>
      </div>
      <a
        href         = {paths.destroy}
        data-method  = "delete"
        data-confirm = {I18n.t("mbc_contracts.delete_confirm", { defaultValue: "Supprimer ce marché ?" })}
        className    = "inline-flex items-center gap-2 h-9 px-3 rounded-md bg-rose-600 text-[13px] font-medium text-white hover:bg-rose-700 shrink-0"
      >
        <FontAwesomeIcon icon="trash" className="text-[12px]" />
        {I18n.t("button.delete", { defaultValue: "Supprimer" })}
      </a>
    </div>
  </div>
)

const App = ({ data }) => {
  if (!data) return null
  return (
    <div className="font-sans bg-slate-50 min-h-screen text-slate-900">
      <Header   contract={data.contract} paths={data.paths} policies={data.policies} statuses={data.statuses || []} />
      <div className="px-8 py-6 space-y-6">
        <KpiStrip     kpis={data.kpis} />
        <LinesSection lines={data.lines || []} paths={data.paths} />
        <TiersSection tiers={data.tiers || []} />
        {data.policies.can_destroy && data.paths.destroy && (
          <DangerZone paths={data.paths} />
        )}
      </div>
    </div>
  )
}

export default App
